import React, { useEffect } from 'react';
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { LanguageProvider } from './context/LanguageContext';
import { ContentProvider } from './context/ContentContext';
import CookieConsent from './components/CookieConsent';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import ServicesPage from './pages/ServicesPage';
import PartnersPage from './pages/PartnersPage';
import NewsPage from './pages/NewsPage';
import CareersPage from './pages/CareersPage';
import ImpressumPage from './pages/ImpressumPage';
import DatenschutzPage from './pages/DatenschutzPage';
import AdminPage from './pages/AdminPage';
import CMSPage from './pages/CMSPage';

// Remove watermark badge
const removeWatermark = () => {
  const selectors = [
    '[class*="emergent"]',
    '[id*="emergent"]',
    'a[href*="emergent"]',
    '[class*="watermark"]',
    '[id*="watermark"]'
  ];
  selectors.forEach(selector => {
    document.querySelectorAll(selector).forEach(el => el.remove());
  });
};

function AppContent() {
  useEffect(() => {
    removeWatermark();
    const interval = setInterval(removeWatermark, 500);
    return () => clearInterval(interval);
  }, []);

  return (
    <LanguageProvider>
      <ContentProvider>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/news" element={<NewsPage />} />
          <Route path="/partners" element={<PartnersPage />} />
          <Route path="/careers" element={<CareersPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/impressum" element={<ImpressumPage />} />
          <Route path="/datenschutz" element={<DatenschutzPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/cms" element={<CMSPage />} />
        </Routes>
        <CookieConsent />
      </ContentProvider>
    </LanguageProvider>
  );
}

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <AppContent />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
